export default "__VITE_ASSET__DCeuNEbO__";